import { CommerceConnectorApi } from "@pes-ui/utils/lib/types/api/commerce-connector-api";
import { ProductsApi } from "@pes-ui/utils/lib/types/api/products-api";

export const getProductCtas = ({
    labels,
    myProducts,
    commerceConnector
}: {
    labels: ProductsApi.Labels;
    myProducts: string[];
    commerceConnector: CommerceConnectorApi.GetCommerceConnectorResponse;
}) => ({
    buttons: {
        cart: {
            isShown: Boolean(commerceConnector?.options?.enableChannelSightOnCart),
            list: [],
            color: 'primaryBlue',
            labels: {
                addLabel: labels.addToCartLabel,
            },
            icons: {
                addIcon: 'segment_retail',
                disableIconInPdpCtaBlock: true
            },
            dataset: {
                daElementId: 'add_p'
            }
        },
        favorites: {
            isShown: !Boolean(commerceConnector?.options?.enableChannelSightOnCart),
            list: myProducts,
            labels: {
                addLabel: labels.addToMyProductsLabel,
                removeLabel: labels.removeFromMyProductsLabel,
            },
            icons: {
                addIcon: 'star_stroke',
                removeIcon: 'star_plain'
            },
            dataset: {
                daElementId: 'add_p'
            }
        }
    },
    productProp: 'repositoryId'
});
